import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import {User} from '../model/Entities/User';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {catchError, tap} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {HttpClient} from '@angular/common/http';
import {ProgressService} from './progress.service';
import {SnackService} from './snack.service';
import {LocalStorageService} from './local-storage.service';
import {ProductFile} from '../model/Entities/ProductFile';
import {Router} from '@angular/router';
import {UserRole} from '../model/Entities/UserRole';

@Injectable()
export class UserService extends ApiService<User> {

    protected apiUrl = 'api/users';  // URL to web api
    protected loginApiUrl = 'api/sessions';

    protected getObjectType(): any {
        return User;
    }

    // constructor(http: HttpClient,
    //             progressService: ProgressService,
    //             snackService: SnackService,
    //             protected localStorageService: LocalStorageService,
    //             private router: Router) {
    //     super(http, progressService, snackService, localStorageService, router);
    // }

    public isLoggedIn() {
        this.localStorageService.set('last-active', Date.now());
        return this.localStorageService.has('logged-user');
    }

    public activate(user: User) {
        user.active = true;
        return this.update(user.id, user);
    }

    public deactivate(user: User) {
        user.active = false;
        return this.update(user.id, user);
    }

    public login(credentials: object): Observable<User> {
        const data = this.decamelizeObject(credentials);
        return this.sendPost(`${this.apiRoot}/${this.loginApiUrl}`, data).do((loginResponse: any) => {
            this.localStorageService.set('logged-user', loginResponse.user);
            this.localStorageService.set('user-token', loginResponse.token);
            this.initAuthorizationHeader();
        });
    }

    public logout() {
        this.router.navigate(['login']);
        return this.sendDelete(`${this.apiRoot}/${this.loginApiUrl}`).do(() => {
            this.localStorageService.unset('logged-user');
            this.localStorageService.unset('user-token');
        });
    }

    public getLoggedUser(): User {
        return this.localStorageService.get('logged-user');
    }

    public updateLoggedUser(): void {
        this.get(this.getLoggedUser().id, {expand: 'role'}).subscribe(u => {
            this.localStorageService.set('logged-user', u);
        });
    }

    public isAdmin(): boolean {
        return this.isLoggedIn() && (this.getLoggedUser().role.name === UserRole.ROLE_ADMIN
            || this.getLoggedUser().role.name === UserRole.ROLE_MANAGER || this.getLoggedUser().role.name === UserRole.ROLE_ACCOUNTANT
            || this.getLoggedUser().role.name === UserRole.ROLE_STORAGE_MANAGER);
    }

    public isAccountant() {
        return this.isLoggedIn() && (this.getLoggedUser().role.name === UserRole.ROLE_ADMIN
            || this.getLoggedUser().role.name === UserRole.ROLE_ACCOUNTANT);
    }
}



// WEBPACK FOOTER //
// /app/src/services/user.service.ts